import * as React from 'react';
import { getApplicationKeys, deleteApplicationKey, createApplicationKey } from '../../repositories/UserRepository';
//import { ApplicationKey } from '../../clients/aasServerClient.generated';
import { TranslateFunction } from 'react-localize-redux';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './ApplicationKeyList.scss';

interface Props {
    userId: string | undefined;
    translate: TranslateFunction;
}


// I added this directly here to make it compile, but Idk if this file is connected called 
export class ApplicationKey 
{
    title!: string ;
    id! :string;
}

interface State {
    applicationKeys?: ApplicationKey[] | undefined;
}

class ApplicationKeyList extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);
        this.state = {
            applicationKeys: undefined
        };
    }

    public componentDidMount() {
        this.fillKeys();
    }

    public componentDidUpdate(prevProps: Props) {
        if (prevProps.userId !== this.props.userId) {
            this.fillKeys();
        }
    }

    public fillKeys = async () => {
        if (this.props.userId) {
            getApplicationKeys(this.props.userId).then(keys => {
                this.setState({
                    applicationKeys: keys
                });
            });
        }
    }

    public deleteKey = (applicationId: string) => {
        if (this.props.userId) {
            deleteApplicationKey(this.props.userId, applicationId).then(() => {
                this.fillKeys();
            })
        }
    }

    public render() {
        const t = this.props.translate;
        if (this.state.applicationKeys) {
            return <React.Fragment>
                <hr className="fill-modal" />
                <h3 className="mb-4 mt-4">{t('users.edit.section.applicationKeys')}</h3>
                <table style={{ width: '100%'}}>
                    {this.state.applicationKeys.map(key => {
                        return (<tr>
                            <td>{key.title}</td>
                            <td className="icon-btn-td" style={{ width: '36px' }}>
                                <Button
                                    color="danger"
                                    onClick={() => {
                                        this.deleteKey(key.id);
                                    }}
                                >
                                    <FontAwesomeIcon icon={['fal', 'trash']} className="noMarginRight" />
                                </Button>
                            </td>
                        </tr>)
                    })}
                </table>
            </React.Fragment>
        } else {
            return null;
        }

    }
}

export default ApplicationKeyList;